import { HolidayEventQueryParams } from '@nextforce/api'

const keys = {
  all: ['holiday_events'],
  list: (params: HolidayEventQueryParams) => [...keys.all, params],
}

export default keys
